import React from "react";

export default ({ children }) => {
  return <section className="layout__panel-container">{children}</section>;
};
